module.exports = __webpack_public_path__ + "img/biter-die-mask2.a673c403.png";